import { VFC } from 'react'
import { useTheme } from '@opallabs/hooks'
import * as styles from './styles'

type FullscreenOverlayProps = {
  isFullScreen: boolean
  onClick: () => void
}

export const FullscreenOverlay: VFC<FullscreenOverlayProps> = ({
  isFullScreen,
  onClick,
}) => {
  const theme = useTheme()
  return (
    <div
      role="presentation"
      css={isFullScreen && [styles.overlay, styles.overlayDynamic({ theme })]}
      aria-hidden={!isFullScreen}
      onClick={onClick}
    />
  )
}
